export function LogoMark({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden>
      <rect width="32" height="32" rx="8" fill="var(--color-accent)" />
      <path d="M11 8.5v15" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      <path d="M12.5 16 20 9.5M12.5 16 20 22.5" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      <circle cx="22.5" cy="8" r="2.5" fill="#fff" />
      <circle cx="22.5" cy="24" r="2.5" fill="#fff" />
    </svg>
  );
}

export function Logo() {
  return (
    <span className="flex items-center gap-2">
      <LogoMark />
      <span className="text-[15px] font-semibold tracking-tight">Kontaktfix</span>
    </span>
  );
}
